
<div class="m-1 mt-2">
  <app-document-library-search 
    [feature]="feature"
    (emitSelectedData)="onSelectionOrDeselection($event)"
    (shouldAddTrainingItemAsDocumentButtonDisplayed)="showOrHideAddButton($event)"
    [panelListScreen]="curriculumDocumentDetails">
  </app-document-library-search>
</div>
<div class="col mb-2 card flex" *ngIf="showAddButton">
  <p-splitButton class="p-splitbutton-menubutton splitBtn" label="Add and Close" (onClick)="addCurriculumAndClose()" [model]="items"></p-splitButton>
</div>

